export enum CalendarAccountErrorDialogState {
    None,
    AccountLoadTokenError,
    AccountLoadNonTokenError,
    RemovedCalendarIds,
}
